import { Params } from '@angular/router';

export type ActionRoute = { commands: string[]; queryParams?: Params };

export enum ActionName {
  UploadNationalIdCard = 'UploadNationalIdCard',
  UploadBankCard = 'UploadBankCard',
  UploadDriversLicense = 'UploadDriversLicense',
  UploadDocument = 'UploadDocument',
  UploadDocumentWithSelector = 'UploadDocumentWithSelector',
  SignDocument = 'SignDocument',
  SignDocumentBatch = 'SignDocumentBatch',
  ApproveDocument = 'ApproveDocument',
  ViewDocument = 'ViewDocument',
  DownloadDocument = 'DownloadDocument',
  CompletePersonalData = 'CompletePersonalData',
  FinancialContact = 'FinancialContact',
  EmergencyContact = 'EmergencyContact',
  Company = 'Company',
  Housing = 'Housing',
  AppliedJobs = 'AppliedJobs',
  ShiftDetail = 'ShiftDetail',
  EventCalendarDaySelected = 'EventCalendarDaySelected',
  EventCalendarShiftDetail = 'EventCalendarShiftDetail',
  EventCalendarEngagementDetail = 'EventCalendarEngagementDetail',
  NewChatMessage = 'NewChatMessage',
  OpenSurvey = 'OpenSurvey',
  StartFlow = 'StartFlow',
  InboxMessage = 'InboxMessage',
  FeedbackWeek = 'FeedbackWeek',
  OpenAppointment = 'OpenAppointment',
  OpenExternalLink = 'OpenExternalLink',
  OpenTimeRegistrationWeek = 'OpenTimeRegistrationWeek'
}

export type Action = {
  name: ActionName;
  data: {
    documentTypeId?: string;
    documentId?: string;
    batchId?: string;
    surveyData?: string;
    flowId?: string;
    engagementId?: string;
    shiftId?: string;
    chatAgentExternalId?: string;
    day?: string;
    appointmentId?: string;
    externalId?: string;
    url?: string;
    year?: string;
    weekNumber?: string;
  };
};
